<div class="container" *ngLet="settingFormChanges$ | async" [formGroup]="settingForm">
  <div class="header">
    <span class="h2-impaired">
      {{ 'VERSION_VISUALLY_IMPAIRED.SETTINGS' | translate }}
    </span>

    <button (click)="close()" class="icon-button impaired-size-56">
      <svg [icon]="icons.Close" class="impaired-size-32" />
    </button>
  </div>

  <div class="setting-sections mt24">
    <span class="h3-impaired">
      {{ 'VERSION_VISUALLY_IMPAIRED.FONT' | translate }}
    </span>
    <div class="section-block" >
      <label class="radio-container"
        >Arial
        <input type="radio" value="Arial" name="font" formControlName="font"/>
        <span class="radio"></span>
      </label>
      <label class="radio-container"
        >Times New Roman
        <input type="radio" name="font" value="TimesNewRoman" formControlName="font"/>
        <span class="radio"></span>
      </label>
    </div>
  </div>

  <div class="setting-sections mt40">
    <span class="h3-impaired">
      {{ 'VERSION_VISUALLY_IMPAIRED.LETTER_SPACING' | translate }}
    </span>
    <div class="section-block">
      <label class="radio-container"
      >  {{ 'VERSION_VISUALLY_IMPAIRED.STANDARD' | translate }}
        <input type="radio" value="standard" name="letterSpacing" formControlName="letterSpacing"/>
        <span class="radio"></span>
      </label>
      <label class="radio-container"
      >  {{ 'VERSION_VISUALLY_IMPAIRED.AVERAGE' | translate }}
        <input type="radio" value="average" name="letterSpacing" formControlName="letterSpacing"/>
        <span class="radio"></span>
      </label>
      <label class="radio-container"
      >  {{ 'VERSION_VISUALLY_IMPAIRED.BIG' | translate }}
        <input type="radio" value="big"  name="letterSpacing" formControlName="letterSpacing"/>
        <span class="radio"></span>
      </label>
    </div>
  </div>


  <div class="setting-sections mt40">
    <span class="h3-impaired">
      {{ 'VERSION_VISUALLY_IMPAIRED.COLOR_SCHEME' | translate }}
    </span>
    <div class="color-scheme-block">
      <div class="color-scheme-item">
        <div (click)="setColorScheme('default')" class="color-scheme-example default-scheme">
            <span class="color-scheme-text">Aa</span>
        </div>
        <label class="radio-container">
          <input type="radio" value="default" name="colorScheme" formControlName="colorScheme" />
          <span class="radio"></span>
        </label>
      </div>

      <div class="color-scheme-item">
        <div (click)="setColorScheme('black')" class="color-scheme-example black-scheme">
          <span class="color-scheme-text">Aa</span>
        </div>
        <label class="radio-container">
          <input type="radio" value="black" name="colorScheme" formControlName="colorScheme"/>
          <span class="radio"></span>
        </label>
      </div>

      <div class="color-scheme-item">
        <div (click)="setColorScheme('blue')" class="color-scheme-example blue-scheme">
          <span class="color-scheme-text">Aa</span>
        </div>
        <label class="radio-container">
          <input type="radio" value="blue" name="colorScheme"  formControlName="colorScheme"/>
          <span class="radio"></span>
        </label>
      </div>

      <div class="color-scheme-item">
        <div (click)="setColorScheme('cream')" class="color-scheme-example cream-scheme">
          <span class="color-scheme-text">Aa</span>
        </div>
        <label class="radio-container">
          <input type="radio" value="cream" name="colorScheme" formControlName="colorScheme"/>
          <span class="radio"></span>
        </label>
      </div>

      <div class="color-scheme-item">
        <div (click)="setColorScheme('brownGreen')" class="color-scheme-example brown-green-scheme">
          <span class="color-scheme-text">Aa</span>
        </div>
        <label class="radio-container">
          <input type="radio" value="brownGreen" name="colorScheme" formControlName="colorScheme"/>
          <span class="radio"></span>
        </label>
      </div>
    </div>
  </div>

  <div>
    <div class="button-sections mt40">
      <button class="button2-impaired setting-button" (click)="setDefaultSettings()">
        {{ 'VERSION_VISUALLY_IMPAIRED.RETURN_DEFAULT_SETTINGS' | translate }}
      </button>
    </div>
  </div>
</div>
